var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button is-primary",class:{ 'is-loading': _vm.state === 'processing' },on:{"click":_vm.download}},[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa",class:{ 'fa-check': _vm.state === 'done', 'fa-download': _vm.state === '', 'fa-times': _vm.state === 'error' }})]),_vm._v(" "),_c('span',[_vm._v("Download All")])])
}
var staticRenderFns = []

export { render, staticRenderFns }